export const activationModalText =
  'Please add the token from VaultRE to activate (Office Integrations -> Third-Party Access).'

export const minimumTokenLength = 12
export const minimumTokenLengthErrMsg = `Minimum token length is ${minimumTokenLength} characters`
